export default __webpack_public_path__ + "static/media/projects-icon.a12b1ee4.svg";